// main menu
(function () {
    let links = document.querySelectorAll('nav#menu a.sub');
    links.forEach(a => {
        a.addEventListener('click', function (e) {
            e.preventDefault();

            let subMenu = this.nextElementSibling;
            subMenu.classList.toggle('opened');

            this.classList.toggle('flipped');
        });
    });

    let expand = document.querySelector('button.expand');
    expand.addEventListener('click', function (e) {
        let menu = document.querySelector('nav#menu');
        menu.classList.toggle('opened');

        this.classList.toggle('flipped');
    });
})();